module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image4e.02eac0ff.jpg";